import { Outlet, useLocation } from "react-router-dom";
import { Drawer } from "@/components/ui/Drawer";
import { Header } from "@/layouts/Header";
import { Sidebar } from "@/layouts/Sidebar";
import { ChatbotWidget } from "@/components/ChatbotWidget";
import { BrandLogo } from "@/components/BrandLogo";
import { useUiStore } from "@/store/uiStore";

export function AppShell() {
  const location = useLocation();
  const hideChatbot =
    location.pathname.startsWith("/privacy") ||
    location.pathname.startsWith("/auth") ||
    location.pathname.startsWith("/login");

  const mobileSidebarOpen = useUiStore((s) => s.mobileSidebarOpen);
  const closeMobileSidebar = useUiStore((s) => s.closeMobileSidebar);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-50 font-sans antialiased dark:bg-zinc-950">
      {/* Accessibility: Skip to main content landmark link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-lg focus:bg-[var(--brand-primary)] focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white focus:shadow-xl focus:outline-none focus:ring-2 focus:ring-white"
      >
        Skip to main content
      </a>

      {/* Desktop persistent sidebar */}
      <div className="hidden md:flex shrink-0 h-full relative z-20">
        <Sidebar />
      </div>

      {/* Mobile off-canvas navigation drawer */}
      <Drawer
        open={mobileSidebarOpen}
        onClose={closeMobileSidebar}
        placement="left"
        size="sm"
        showCloseButton={true}
        title={
          <div className="flex items-center gap-2">
            <BrandLogo className="h-6 w-6 rounded-md" />
            <span className="font-bold text-sm tracking-tight text-slate-900 dark:text-zinc-50">
              MarketIQ
            </span>
          </div>
        }
        contentClassName="p-0 flex flex-col flex-1 min-h-0 overflow-hidden"
        className="w-[280px] max-w-[85vw]"
        testId="mobile-sidebar-drawer"
      >
        <Sidebar
          forceExpanded
          onNavigate={closeMobileSidebar}
          className="w-full h-full border-r-0 shadow-none"
        />
      </Drawer>

      {/* Main viewport container */}
      <div className="flex min-w-0 flex-1 flex-col h-full overflow-hidden">
        <Header />
        <main
          id="main-content"
          tabIndex={-1}
          className="min-h-0 flex-1 overflow-y-auto px-4 py-3 sm:px-5 sm:py-3.5 md:px-5 md:py-4 outline-none"
        >
          <Outlet />
        </main>
      </div>

      {!hideChatbot ? <ChatbotWidget /> : null}
    </div>
  );
}
